module.exports = __webpack_public_path__ + "img/29.6939f0a5.png";